<template>
  <div v-html="content" />
</template>

<script>
  export default {
    name: 'HighlightedUrl',
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      field: {
        type: String,
        default: ''
      },
    },
    computed: {
      content () {
        let value = this.item[this.field]
        if (this.field === 'frontendUrl') {
          return this.getHtmlString(this.item.unreplacedFrontendProperties.unreplacedProperties, value)
        } else if (this.field === 'backendUrl') {
          return this.getHtmlString(this.item.unreplacedBackendProperties.unreplacedProperties, value)
        } else {
          return this.getHtmlString(this.item.unreplacedHistoryProperties.unreplacedProperties, value)
        }
      }
    },
    methods: {
      getHtmlString (properties, url) {
        properties.forEach((element) => {
          let reg = element.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
          url = url.replace(new RegExp(reg), '<span style="color: red">$&</span>')
        })
        return url
      }
    },
  }
</script>

<style scoped>

</style>
